<template>
  <HelpCenterPicture
    :loading="loading"
    :picture="post.picture"
    class="help-center-post-image__component"
  />
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterPicture from 'help-center/components/HelpCenterPicture'

const props = defineProps({
  lazy: Boolean,
  post: {
    type: Object,
    required: true
  }
})

const loading = computed(() => {
  if (props.lazy) {
    return 'lazy'
  } else {
    return 'eager'
  }
})
</script>

<style lang="scss">
.help-center-post-image__component {
  border-radius: 6px;
}
</style>
